module.exports = __webpack_public_path__ + "static/media/Sharp-LQ150X1LX96-Mechanical-Drawing.9d07fcbd.gif";